"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batonIntBaseUrl = exports.batonProdBaseUrl = void 0;
exports.batonProdBaseUrl = "https://baton.fi.cimpress.io";
exports.batonIntBaseUrl = "https://int-baton.fi.cimpress.io";
